import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  fileDashboardSidebar: {
    backgroundColor: '#1F1D2B',
    width: '18vw',
    '@media(max-width:1281px)': {
      width: '8rem',
      position: 'static',
      '& > button': {
        display: 'none',
      },
    },
  },
  fileDashboardInnerSidebar: {
    padding: '3.8rem 2rem 2rem',
  },
  sidebarTitle: {
    fontSize: '1.8rem',
    letterSpacing: '0.07em',
    marginTop: '0',
    marginBottom: '3rem',
    textTransform: 'uppercase',
    color: colors.neutral[500],
    '@media(max-width:1281px)': {
      display: 'none',
    },
  },

  dashboardsList: {
    padding: 0,
    margin: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '2.6rem',
  },
  dashboardItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.6rem',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[500],
    fontWeight: 700,
    cursor: 'pointer',
    '&:hover': {
      extend: 'dashboardActiveItem',
    },
    '& svg': {
      padding: '0.8rem',
      borderRadius: '1rem',
      backgroundColor: '#353340',
      flexShrink: 0,
      '&:hover': {
        extend: 'dashboardActiveItem',
      },
    },
    '@media(max-width:1281px)': {
      '& span': {
        display: 'none',
      },
    },
  },
  // These properties are used in dashboardItem class using 'extend'
  dashboardActiveItem: {
    color: colors.neutral.white,
    '&:nth-child(4n + 1)': {
      '& svg': {
        fill: colors.neutral.white,
        background: colors.orange[500],
      },
    },
    '&:nth-child(4n + 2)': {
      '& svg': {
        fill: colors.neutral.white,
        background: colors.blue[500],
      },
    },
    '&:nth-child(4n + 3)': {
      '& svg': {
        fill: colors.neutral.white,
        background: colors.green[500],
      },
    },
    '&:nth-child(4n)': {
      '& svg': {
        fill: colors.neutral.white,
        background: colors.purple[500],
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
